import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';
import { graphql, withApollo } from 'react-apollo';
import { Table, Button } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import { ListRafflesQuery } from './queries';

function RaffleLogo({ logo }) {
  const [errored, setErrored] = useState(false);
  if (!logo) return <span>No logo</span>;
  if (errored) return <span style={{ color: '#999' }}>Image unavailable</span>;
  return (
    <img
      height={100}
      src={logo}
      alt="logo"
      referrerPolicy="no-referrer"
      onError={() => setErrored(true)}
    />
  );
}

class List extends Component {
  render() {
    const { loading, error, Raffles } = this.props.data;

    if (error) return `Error: ${error}`;

    return (
      <div className="container">
        Raffles Websites

        <Button.Group size="small" className="is-right">
          <Button>
            <Link to="/raffles/new"><AntIcon type="plus" /> New Item</Link>
          </Button>
        </Button.Group>
        <Table
          columns={[
            {
              title: 'Title',
              dataIndex: 'name',
              render: (name, { _id }) => {
                return <Link to={`/raffles/${_id}/edit`}>{name}</Link>;
              }
            },
            {
              title: 'Logo',
              dataIndex: 'logo',
              width: '30%',
              render: (logo) => <RaffleLogo logo={logo} />
            }
          ]}
          loading={loading}
          rowKey='_id'
          dataSource={Raffles}
        />
      </div>
    );
  }
}

export default withApollo(graphql(ListRafflesQuery, { options: { fetchPolicy: 'no-cache' } })(List));
